const isObjectEmpty = (object) => {
  for (const property in object) {
    return false;
  }
  return true;
};

export default isObjectEmpty;
